import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import AdminDashboard from "./AdminDashboard";
import VendorDashboard from "./VendorDashboard";
import VendorManagerDashboard from "./VendorManagerDashboard";

const Dashboard = () => {
  const { user } = useContext(AuthContext);

  if (user?.roleSlug === "vendor") return <VendorDashboard />;
  if (user?.roleSlug === "vendor_manager") return <VendorManagerDashboard />;
  return <AdminDashboard />;
};

export default Dashboard;